import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'replaceUnderscoreWithSpace',
})
export class StringReplacePipe implements PipeTransform {
  transform(value: any): any {
    return (value ?? '').replace(/_/g, ' ');
  }
}
